export const RoomType = {
  DM: 'dm',
  GROUP: 'group',
  COURSE: 'course',
  ORGANIZATION: 'organization',
  SUBMISSION: 'submission',
  USER_NOTIFICATIONS: 'user_notifications',
} as const;

export type RoomTypeValue = (typeof RoomType)[keyof typeof RoomType];
